import React from 'react'
import { useTranslation } from 'i18n'
import PlaceholderImage from 'components/PlaceholderImage'

const ChecklistResult = ({
  headline,
  text,
  imageUrl,
  imageAlt,
  shareIcons = null,
}) => {
  const { t } = useTranslation('checklist')
  return (
    <div className="checklist-result">
      <span className={`eyebrow`}>{t('resultEyebrow')}</span>
      {imageUrl && (
        <figure className="checklist-result-img">
          <PlaceholderImage
            src={imageUrl}
            alt={imageAlt}
            height={400}
            width={600}
          />
        </figure>
      )}
      <div className="checklist-result-details">
        {headline && <h1 className={`step-content__title`} dangerouslySetInnerHTML={{ __html: headline }} />}
        {text && <div dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
      {shareIcons}
    </div>
  )
}
export default ChecklistResult
